import { Card, Col, Form, Offcanvas, Row, Spinner } from "react-bootstrap";
import Moment from "react-moment";

const ViewSiteShipment = ({
  shipmentData,
  Show,
  Hide,
  Title,
}) => {
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="mb-3">
            <Card.Body className="p-3">
              <Row>
                <Col xs={6}>
                  <div className="text-muted small">Shipment Number</div>
                  <Form.Label>{shipmentData?.shipmentNumber}</Form.Label>
                </Col>
                <Col xs={6}>
                  <div className="text-muted small">Shipment Type</div>
                  <Form.Label className="text-capitalize">{shipmentData?.shipmentType} Shipment</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Depot-Site</div>
                  <Form.Label>{shipmentData?.depot}-{shipmentData?.siteName}</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Corier</div>
                  <Form.Label>{shipmentData?.corier}</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Tracking / AWB No.</div>
                  <Form.Label>{shipmentData?.trackingId}</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Temp logger Id</div>
                  <Form.Label>{shipmentData?.tempLoggerId}</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Temperature on Receipt</div>
                  <Form.Label>{shipmentData?.temperatureOnReceipt || "_"}</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Shipiment Condition</div>
                  <Form.Label className="text-capitalize">{shipmentData?.shipmentCondition === "minorDamaged" ? "Minor Damaged" : shipmentData?.shipmentCondition}</Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Dispatched DT</div>
                  <Form.Label>
                    {shipmentData?.dispatchedDT ?
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {shipmentData?.dispatchedDT}
                      </Moment>
                      : "_"}
                  </Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Received DT</div>
                  <Form.Label>
                    {shipmentData?.receivedDT ?
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {shipmentData?.receivedDT}
                      </Moment>
                      : "_"}
                  </Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Created DT</div>
                  <Form.Label>
                    {shipmentData?.createdAt ?
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {shipmentData?.createdAt}
                      </Moment>
                      : "_"}
                  </Form.Label>
                </Col>
                <Col xs={6} className="mt-2">
                  <div className="text-muted small">Last Updated DT</div>
                  <Form.Label>
                    {shipmentData?.updatedAt ?
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {shipmentData?.updatedAt}
                      </Moment>
                      : "_"}
                  </Form.Label>
                </Col>
                <Col xs={12} className="mt-2">
                  <div className="text-muted small">Comment</div>
                  <Form.Label>
                    {shipmentData?.comment || "_"}
                  </Form.Label>
                </Col>
                {shipmentData?.totalKit?.length > 0 &&
                  <Col xs={12} className="mt-2">
                    <div className="text-muted small">Total Kit</div>
                    {shipmentData?.kitList?.map((item) => (
                      <Form.Check
                        key={item?.kitId}
                        type="checkbox"
                        checked
                        disabled
                        label={`${item?.kitNumber}${item?.columns?.filter(
                          (column) => column?.isUnique === "yes"
                        )?.length > 0
                          ? ` (${item?.columns
                            ?.filter((column) => column?.isUnique === "yes")
                            ?.map(
                              (data) => `${data?.columnName}: ${data?.columnValue}`
                            )
                            ?.join(", ")})`
                          : ""
                          }`}
                      />
                    ))}
                  </Col>
                }
              </Row>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSiteShipment;
